import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListMultiple = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-multiple" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 9.75,
			y: 6.761,
			width: 13.5,
			height: 16.5,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,20.261h-3a1.5,1.5,0,0,1-1.5-1.5V5.261a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,0,1,1.5,1.5v1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,17.261h-3a1.5,1.5,0,0,1-1.5-1.5V2.261a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,0,1,1.5,1.5v1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 11.261,
			x2: 20.25,
			y2: 11.261
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "12.75 10.511 13.5 11.261 15 9.761"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 15.761,
			x2: 20.25,
			y2: 15.761
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "12.75 15.011 13.5 15.761 15 14.261"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 20.261,
			x2: 20.25,
			y2: 20.261
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "12.75 19.511 13.5 20.261 15 18.761"
		})
	]
});
export default SvgTaskListMultiple;
